import { defineEvent } from '../types/event';
export var QUICKVIEW_SIZE_SELECTOR_CLICK = defineEvent({
    platforms: [
        {
            name: 'Optimizely',
            alias: 'Clicks_on_QuickView_Size_Selectors'
        }
    ]
});
